module.exports = __webpack_public_path__ + "img/RattVisatLogo.b0489754.svg";